import React, { Component, memo, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import MonthYearPicker from '../../../components/UI/dataPicker/monthYearPicker.jsx'
import CajaTextoBusqueda from '../../../components/UI/cajaTexto/cajaTextoBusqueda.jsx'

export function peridodoFiscal(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className="content">
                    <div className="content-box">
                        <div className="row">
                            <div className='row'>                                
                                <MonthYearPicker id="InicioPeriodo" col="4" pvalue={props.Datos.InicioPeriodo.value} attributes={props.Datos.InicioPeriodo.attributes} label={props.Datos.InicioPeriodo.attributes.label} handleChange={props.onhandleChangeDate} />
                                <MonthYearPicker id="FinPeriodo" col="4" pvalue={props.Datos.FinPeriodo.value} attributes={props.Datos.FinPeriodo.attributes} label={props.Datos.FinPeriodo.attributes.label} handleChange={props.onhandleChangeDate} />
                                <MonthYearPicker id="Periodo" col="4" pvalue={props.Datos.Periodo.value} attributes={props.Datos.Periodo.attributes} label={props.Datos.Periodo.attributes.label} handleChange={props.onhandleChangeDate} />
                            </div>
                            <div className='row'>
                                <CajaTextoBusqueda col="6" id="PerdGananNombre" type="text" label={props.Datos.PerdGananNombre.attributes.label} value={props.Datos.PerdGananNombre.value} attributes={props.Datos.PerdGananNombre.attributes} onChangeInput={props.onChangeInput} onClick={() => props.handleModalTree()} />
                                <CajaTextoBusqueda col="6" id="PerdGananCCNombre" type="text" label={props.Datos.PerdGananCCNombre.attributes.label} value={props.Datos.PerdGananCCNombre.value} attributes={props.Datos.PerdGananCCNombre.attributes} onChangeInput={props.onChangeInput} onClick={() => props.handleModal()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
export default (withRouter(memo(peridodoFiscal)));